import { useHaltPropagation } from "@/components/hooks/utility/useHaltPropagation";
import { IUseAcknowledgementPost } from "@/interfaces/activityFeedNotifications";

export const AcknowlegementPostConstants = {
    responseMessage : "Confirmed",
    deletedBannerMessage : "Content Archived"
}

export function getAcknowledgementPost({isPopOut, timeStamp, dateStamp, parentList, getOpenOnWebLink, onDownloadReportClick, content, appDetails}: IUseAcknowledgementPost) {
    const screenClassName = isPopOut ? "" : "full-screen-styling";
    const showDeletedBanner = content.isArchived;
    const activityInfo = {
        className: screenClassName, 
        time: isPopOut ? timeStamp : undefined, 
        contentTitle: parentList?.title,
        contentLink: parentList?.link,
        contentExistsInMultiplePlaces: content.existsInMultiplePlaces,
        appImageUrl: appDetails.isMultipleAppOrganisation ? appDetails.iconUrl : "",
        appName: appDetails.isMultipleAppOrganisation ? appDetails.name : "",
        dateStamp: `${timeStamp} · ${dateStamp}`
    }

    const webLink = !content.isArchived ? getOpenOnWebLink : undefined
    const downloadReportLink = !content.isArchived ? downloadReport : undefined;
    
    function downloadReport(e?: any) {
        useHaltPropagation(e);
        onDownloadReportClick();
    }
    
    return { screenClassName, showDeletedBanner, webLink, downloadReportLink, activityInfo }
};